import { AttachMoney, Description } from '@mui/icons-material';
import { Button, CardContainer } from 'finara-components';

import { PaymentType } from '@/types/payment';

interface TypeSelectionProps {
  onSelect: (paymentType: PaymentType) => void;
}

export const TypeSelection: React.FC<TypeSelectionProps> = ({ onSelect }) => {
  return (
    <div className="max-w-4xl mx-auto">
      {/* Header */}
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-black/10 dark:bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <AttachMoney className="text-muted" fontSize="large" />
        </div>
        <h2 className="text-2xl font-bold text-brand-white mb-2">Sistema de Pagos</h2>
        <p className="text-muted">Realizar pagos para tu organización</p>
      </div>

      {/* Payment Type Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {/* Single Payment Card */}
        <CardContainer className="p-6 hover:shadow-lg transition-shadow cursor-pointer">
          <div className="text-center flex flex-col justify-between h-full">
            <div>
              <div className="w-16 h-16 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Description className="text-blue-600" fontSize="large" />
              </div>
              <h3 className="text-xl font-semibold text-brand-white mb-2">Pago Singular</h3>
              <p className="text-muted mb-10">Realiza un pago individual</p>
            </div>

            {/* Features */}
            <div className="space-y-3 mb-6">
              <div className="flex items-center text-sm text-brand-white">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Validación en tiempo real
              </div>
              <div className="flex items-center text-sm text-brand-white">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Formulario del beneficiario
              </div>
              <div className="flex items-center text-sm text-brand-white">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Autorización OTP
              </div>
              <div className="flex items-center text-sm text-brand-white">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Ejecución inmediata o programada
              </div>
            </div>

            <Button variant="black" size="large" fullWidth onClick={() => onSelect('singular')}>
              Iniciar Pago Singular
            </Button>
          </div>
        </CardContainer>

        {/* Bulk Payment Card */}
        <CardContainer className="p-6 hover:shadow-lg transition-shadow cursor-pointer h-full">
          <div className="text-center flex flex-col justify-between h-full">
            <div>
              <div className="w-16 h-16 bg-purple-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Description className="text-purple-600" fontSize="large" />
              </div>
              <h3 className="text-xl font-semibold text-brand-white mb-2">Pagos Múltiples (Bulk)</h3>
              <p className="text-muted mb-10">
                Procesa múltiples pagos usando plantilla Excel o CSV
              </p>
            </div>

            {/* Features */}
            <div className="space-y-3 mb-6 text-left">
              <div className="flex items-center text-sm text-brand-white">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Validación masiva
              </div>
              <div className="flex items-center text-sm text-brand-white">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Plantilla Excel/CSV
              </div>
              <div className="flex items-center text-sm text-brand-white">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Autorización OTP
              </div>
              <div className="flex items-center text-sm text-brand-white">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                Ejecución por lotes
              </div>
            </div>

            <Button variant="black" size="large" fullWidth onClick={() => onSelect('bulk')}>
              Iniciar Pagos Múltiples
            </Button>
          </div>
        </CardContainer>
      </div>
    </div>
  );
};
